<div class="header">
    <div style="text-align: right" class="pull-right">
        <mat-spinner *ngIf="loadingAction" matSuffix [diameter]="20"></mat-spinner>
        <button *ngIf="!loadingAction" matTooltip="Cancelar" (click)="cancel()" mat-icon-button class="card-inline">
      <mat-icon>clear</mat-icon>
    </button>
        <button *ngIf="!loadingAction" matTooltip="Finalizar atención" (click)="finalizeMedicalAppointmentCare()" mat-icon-button class="card-inline">
      <mat-icon>done</mat-icon>
    </button>
        <button *ngIf="!loadingAction" mat-icon-button [matMenuTriggerFor]="menuItem">
      <mat-icon>more_vert</mat-icon>
    </button>
        <mat-menu #menuItem="matMenu">

            <button (click)="openMedicalAppointmentObservationDialog()" mat-menu-item>
        <mat-icon>search</mat-icon><span>Ver observaciones</span>
      </button>
            <!-- <button (click)="verMuestras()" mat-menu-item>
        <mat-icon>search</mat-icon><span>Muestras</span>
      </button> -->
            <button (click)="verPreparaciones()" mat-menu-item>
        <mat-icon>search</mat-icon><span>Prep. y Proced.</span>
      </button>
            <app-medical-appointment-reappointment-control (onReAppointmentChange)="onReAppointmentChange()" [medicalAppointmentId]="medicalAppointmentId">
            </app-medical-appointment-reappointment-control>

        </mat-menu>
    </div>
</div>

<div *ngIf="!loading" class="card-base margin-botton-medium">
    <div class="card-content-scan">
        <div class="card-container">
            <div class="card-content">
                <app-received-lab-sample #receivedLab [appointmentId]="medicalAppointmentId"></app-received-lab-sample>
                <div *ngIf="info">
                    <div class="appointment-practices">
                        Prácticas:
                        <ng-container *ngFor="let name of getProcedureNames(info.MedicalAppointmentProcedurePrincipals, 'PracticeRegionName'); let last = last">
                            <span class="procedure-name">{{ name }}</span><span *ngIf="!last">, </span>
                        </ng-container>
                    </div>
                    <div class="appointment-aditionals">
                        Adicionales:
                        <ng-container *ngFor="let name of getProcedureNames(info.MedicalAppointmentProcedureAditionals, 'PracticeRegionAditionalName'); let last = last">
                            <span class="procedure-name">{{ name }}</span><span *ngIf="!last">, </span>
                        </ng-container>
                    </div>
                    <div class="appointment-sets">
                        Sets:
                        <ng-container *ngFor="let name of getProcedureNames(info.MedicalAppointmentProcedureSetSupplies, 'SetSupplieName'); let last = last">
                            <span class="procedure-name">{{ name }}</span><span *ngIf="!last">, </span>
                        </ng-container>
                    </div>
                </div>
                <medical-order-scann-control [canScann]="false" [hideProcedures]="true" [deliveryDate]="deliveryDate" [medicalorderId]="medicalOrderId"></medical-order-scann-control>
            </div>
        </div>
    </div>
</div>